import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import AnchorLink from "react-anchor-link-smooth-scroll";

import Slide1 from "../../images/slider/slide-1.jpg";
import Slide2 from "../../images/slider/slide-2.jpg";
import Slide3 from "../../images/slider/slide-3-.jpg";

import arrow from "../../images/down-arrow.svg";

const slides = [
  {
    img: Slide1,
    title1: "Corporate Interior Excellence",
    title2: "Designed to Perform",
  },
  {
    img: Slide2,
    title1: "Architecture, Interiors & Execution",
    title2: "Delivered with Precision",
  },
  {
    img: Slide3,
    title1: "End-to-End Design Solutions",
    title2: "Built with Excellence",
  },
];

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section
      className="wpo-hero-slider"
      style={{ position: "relative", overflow: "hidden", background: "#fff" }}
    >
      <Swiper
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        loop
        speed={1200}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        pagination={{
          clickable: true,
          el: ".swiper-pagination",
          type: "fraction",
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            <div
              className="slide-inner"
              style={{
                position: "relative",
                minHeight: "100vh",
                overflow: "hidden",
              }}
            >
              {/* 🔹 FADED BACKGROUND */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${slide.img})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  opacity: 0.18,
                  zIndex: 1,
                }}
              />

              {/* 🔹 LEFT SLICE */}
              <div
                key={`left-${activeIndex}`}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "33.3334%",
                  height: "100%",
                  backgroundImage: `url(${slide.img})`,
                  backgroundSize: "300% 100%",
                  backgroundPosition: "0% center",
                  transform: "translateY(-100%)",
                  animation: "sideIn 3.8s cubic-bezier(0.25,0.8,0.25,1) forwards",
                  zIndex: 2,
                }}
              />

              {/* 🔹 RIGHT SLICE */}
              <div
                key={`right-${activeIndex}`}
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "33.3334%",
                  height: "100%",
                  backgroundImage: `url(${slide.img})`,
                  backgroundSize: "300% 100%",
                  backgroundPosition: "100% center",
                  transform: "translateY(-100%)",
                  animation: "sideIn 3.8s cubic-bezier(0.25,0.8,0.25,1) forwards",
                  zIndex: 2,
                }}
              />

              {/* 🔹 MIDDLE SLICE */}
              <div
                key={`middle-${activeIndex}`}
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: "33.3333%",
                  width: "33.3334%",
                  height: "100%",
                  backgroundImage: `url(${slide.img})`,
                  backgroundSize: "300% 100%",
                  backgroundPosition: "50% center",
                  transform: "translateY(100%)",
                  animation: "middleIn 3.8s cubic-bezier(0.25,0.8,0.25,1) forwards",
                  zIndex: 2,
                }}
              />

              {/* 🔹 TEXT (UNCHANGED) */}
              <div
                className="container"
                style={{
                  position: "relative",
                  zIndex: 3,
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="slide-content">
                  <div className="slide-sub-title">
                    <h2>
                      {/* {slide.title1} */}
                      {/* <span>
                        <img src={TextImg} alt="" />
                      </span> */}
                      {/* {slide.title2} */}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}

        <div className="swiper-pagination"></div>
      </Swiper>

      {/* 🔹 SCROLL BUTTON */}
      <AnchorLink href="#about" className="scroll-btn">
        <span>Scroll For More</span>
        <div className="scroll-befor">
          <img src={arrow} alt="" />
        </div>
      </AnchorLink>

      {/* 🔹 KEYFRAMES */}
      <style>{`
        @keyframes sideIn {
          to { transform: translateY(0); }
        }
        @keyframes middleIn {
          to { transform: translateY(0); }
        }
      `}</style>
    </section>
  );
};

export default Hero;
